module.exports = __webpack_public_path__ + "static/st1-11-6e4fee617c8ff75d59dfb20fc589abdf.jpg";